import React from "react";
import "./orderTableLabel.scss";

import { ReactComponent as Truck } from "../../icons/truck.svg";
import { ReactComponent as Airplane } from "../../icons/airplane.svg";

const OrderTableLabel = ({ txt, order }) => {
  return (
    <div className="order-table-label">
      {order?.branch?.address === "China Land" &&
        order?.status !== "AWAITING" && <Truck />}
      {order?.branch?.address === "China Air" &&
        order.status !== "AWAITING" && <Airplane />}
      {order?.branch?.name === "USA" &&
        order.status !== "AWAITING" && <Airplane />}
      <div className="txt-l">
        {txt?.length > 12 ? `...${txt.slice(-12)}` : txt}
      </div>
    </div>
  );
};

export default OrderTableLabel;
